import { initializeApp } from "firebase/app";
import {
  browserLocalPersistence,
  browserPopupRedirectResolver,
  initializeAuth,
} from "firebase/auth";
import { initializeFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBS4g9PNLpVDlc4t3fyQxcqYnx9FDCGKoQ",
  authDomain: "instacram-eaf33.firebaseapp.com",
  projectId: "instacram-eaf33",
  storageBucket: "instacram-eaf33.appspot.com",
  messagingSenderId: "768932240580",
  appId: "1:768932240580:web:63b9c515d3064ca6c87d91",
  measurementId: "G-9CY1JEJWC8",
};

const app = initializeApp(firebaseConfig);

export const auth = initializeAuth(app, {
  persistence: browserLocalPersistence,
  popupRedirectResolver: browserPopupRedirectResolver,
});
export const db = initializeFirestore(app, {
  experimentalAutoDetectLongPolling: true,
  useFetchStreams: false,
});
export const storage = getStorage(app);
